export default __webpack_public_path__ + "static/media/Prysmian_Logo_RGB_night.5760bbbd.webp";